import { UserInterface } from '../../domain/interfaces/user_interface';
import { UserRepository } from '../../domain/repository/user_repository';
import { UserApiService } from '../data_source/remote/user_api_service';

export class UserRepositoryImpl implements UserRepository {
  private userApiService: UserApiService;

  constructor() {
    this.userApiService = new UserApiService();
  }

    async getMyUserProfile(): Promise<UserInterface> {
        const response = await this.userApiService.getMyUserProfile();
        if (response.status === 200) {
            const company = response.data['_companyId'];
            return {
                userId: response.data['_id'],
                email: response.data['email'],
                firstname: response.data['firstname'],
                lastname: response.data['lastname'],
                profilePicture: response.data['picture'],
                description: response.data['description'],
                nbExtends: response.data['nbExtends'],
                experience: response.data['experience'],
                nbVibes: response.data['nbVibes'],
                careerStatus: response.data['career_status'],
                communication: response.data['communication'],
                verified: response.data['emailVerified'],
                revalidationRequestedAt: response.data['revalidationRequestedAt'] ?? null,
                revalidationEmailSentAt: response.data['revalidationEmailSentAt'] ?? null,
                company: company && {
                    id: company['_id'],
                    name: company['name'],
                    picture: company['picture'],
                    pin: company['code'],
                    permissions: company['permissions'] || {
                        course: false,
                        ressource: false,
                        whiteLabel: false,
                    },
                    limits: company['limits'] || {
                      pointsCareerOpen: 50,
                      pointsFinishTheme: 200,
                    },
                    needEmailVerified: company['needEmailVerified'],
                    partners: (company['_companyIds'] || []).map((partner: { _id: string; name: string; picture?: string }) => ({
                        id: partner._id,
                        name: partner.name,
                        picture: partner.picture,
                    })),
                },
                banned: response.data['banned'],
                course_theme: response.data['course_theme'] || [],
            };
        }
        throw new Error("Failed to fetch user profile");
    }

    async updateMyCareerStatus(status: string): Promise<boolean> {
      const response = await this.userApiService.updateMyUserProfile(
        JSON.stringify({ career_status: status }),
      );
      if (response.status !== 200) {
        throw new Error('Failed to update career status');
      }
      return true;
    }
}